import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {SectionTitle} from "../../Sections";
import {sortBasedOnState} from "../../../sorting/sort";
import {IdeasTableHeader} from "./IdeasTableHeader";
import {IdeasTableBody} from "./IdeasTableBody";
import {authorBackgroundColour} from "../../../../style/styleConsts";
import IdeaExportButton from "./IdeaExportButton";

const OpenIdeasContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-grow: 1;
    flex-shrink: 1;
    background-color: ${authorBackgroundColour};
`;


const OpenIdeasTable = ({
                            ideaActions,
                            authorActions,
                            openIdeas,
                            editingIdeaId,
                            selectedIdeaAction,
                            sort,
                            commentLengthLimit,
                            ideaManagementBlocked
                        }) => {
    const [tableHasScroll, setTableHasScroll] = useState(false);
    const tableRef = useRef(null);

    useEffect(() => {
        function updateTableHasScroll() {
            if (tableRef.current) {
                setTableHasScroll(tableRef.current.scrollHeight > tableRef.current.clientHeight);
            }
        }

        updateTableHasScroll();
        addEventListener("resize", updateTableHasScroll);

        return function cleanup() {
            removeEventListener("resize", updateTableHasScroll);
        };
    });

    const sortedIdeas = sortBasedOnState(openIdeas, sort);
    return (
        <OpenIdeasContainer className="t-open-ideas">
            <SectionTitle>
                <span>Open Ideas</span>
                <IdeaExportButton ideas={sortedIdeas}/>
            </SectionTitle>
            <IdeasTableHeader authorActions={authorActions}
                              tableHasScroll={tableHasScroll}
                              ideaManagementBlocked={ideaManagementBlocked}
                              sort={sort}/>
            <IdeasTableBody sortedIdeas={sortedIdeas}
                            tableRef={tableRef}
                            authorActions={authorActions}
                            editingIdeaId={editingIdeaId}
                            selectedIdeaAction={selectedIdeaAction}
                            ideaActions={ideaActions}
                            ideaManagementBlocked={ideaManagementBlocked}
                            commentLengthLimit={commentLengthLimit}/>
        </OpenIdeasContainer>
    );
};

export default OpenIdeasTable;